// intersectionObserver.js
const intersectionObserver = () => {
    document.addEventListener("DOMContentLoaded", () => {
      // Select elements that should be animated into view
      const observableElements = document.querySelectorAll('.observable');
      // Select all elements that need the parallax effect.
      const parallaxElements = document.querySelectorAll('.parallax');
  
      // IntersectionObserver to add a class when an element comes into view
      if ("IntersectionObserver" in window) {
        const rootMarginValue =
          window.innerWidth < 960 ? '-100px 0px -100px 0px' : '0px 0px -200px 0px';
  
        const observerOptions = {
          root: null, // Use the viewport as the root
          rootMargin: rootMarginValue,
        };
  
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              entry.target.classList.remove('observable');
            }
          });
        }, observerOptions);
  
        observableElements.forEach(el => {
          observer.observe(el);
        });
      } else {
        // Fallback for browsers that don't support IntersectionObserver
        console.warn("IntersectionObserver not supported in this browser.");
      }
  
      // ------------------------------
      // Parallax scroll effect setup
      // ------------------------------
      // These constants define the vertical translation range.
      const MIN_TRANSLATE = -10;    // When the element is just entering view.
      const MAX_TRANSLATE = 10;   // When the element has completely passed.
  
      let ticking = false;
  
      const updateParallax = () => {
        parallaxElements.forEach(el => {
          const rect = el.getBoundingClientRect();
  
          // Compute a progress value:
          // When the element's top is at the bottom of the viewport, progress = 0.
          // When the element's bottom is at the top of the viewport, progress = 1.
          const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
  
          // Clamp the progress between 0 and 1.
          const clampedProgress = Math.min(Math.max(progress, 0), 1);
  
          // Interpolate the translate value between MIN_TRANSLATE and MAX_TRANSLATE.
          const translateValue = MIN_TRANSLATE + clampedProgress * (MAX_TRANSLATE - MIN_TRANSLATE);
  
          // Apply the transform. (You can remove or modify the scale effect if desired.)
          el.style.transform = `translateY(${translateValue}%) scale(1.2)`;
        });
        ticking = false;
      };
  
      const onScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      };
  
      // Listen to scroll events.
      window.addEventListener('scroll', onScroll);
      // Run once at initialization.
      updateParallax();
    });
  };
  
  export default intersectionObserver;
  